import { render, staticRenderFns } from "./BigImg.vue?vue&type=template&id=4d1a4330&scoped=true&"
import script from "./BigImg.vue?vue&type=script&lang=js&"
export * from "./BigImg.vue?vue&type=script&lang=js&"
import style0 from "./BigImg.vue?vue&type=style&index=0&id=4d1a4330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a4330",
  null
  
)

export default component.exports